import React, {useRef, useEffect, Suspense, lazy} from 'react';
import {useLocation, Routes, Route} from 'react-router-dom';
import ScrollReveal from './utils/ScrollReveal';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views — Home stays eager (landing route); the rest are code-split.
import Home from './views/Home';
import APIContextProvider from "./apiContext";

const Dataset     = lazy(() => import('./views/dataset'));
const Leaderboard = lazy(() => import('./views/leaderboard'));
const Submit      = lazy(() => import('./views/submit'));
const Download    = lazy(() => import('./views/download'));
const Examples    = lazy(() => import('./views/examples'));
const Contact     = lazy(() => import('./components/layout/Contact'));

const App = () => {

    const childRef = useRef();
    let location = useLocation();

    useEffect(() => {
        document.body.classList.add('is-loaded')
        childRef.current.init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <APIContextProvider>
            <ScrollReveal
                ref={childRef}
                children={() => (
                    <Suspense fallback={null}>
                        <Routes>
                            <Route path="/" element={<LayoutDefault><Home /></LayoutDefault>} />
                            <Route path="/dataset" element={<LayoutDefault><Dataset /></LayoutDefault>} />
                            <Route path="/download" element={<LayoutDefault><Download /></LayoutDefault>} />
                            <Route path="/examples" element={<LayoutDefault><Examples /></LayoutDefault>} />
                            <Route path="/submit" element={<LayoutDefault><Submit /></LayoutDefault>} />
                            <Route path="/leaderboard" element={<LayoutDefault><Leaderboard /></LayoutDefault>} />
                            <Route path="/contact" element={<LayoutDefault><Contact /></LayoutDefault>} />
                        </Routes>
                    </Suspense>
                )}/>
        </APIContextProvider>
    );
}

export default App;
